/** CSV export for partner staff performance report (not schedule/leave). */

function esc(value) {
  const text = String(value ?? '');
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function monthRangeFromPicker(monthValue) {
  if (!monthValue || !/^\d{4}-\d{2}$/.test(monthValue)) {
    return null;
  }
  const [y, m] = monthValue.split('-').map(Number);
  const from = new Date(y, m - 1, 1);
  const to = new Date(y, m, 0);
  const pad = (n) => `${n}`.padStart(2, '0');
  return {
    fromDate: `${from.getFullYear()}-${pad(from.getMonth() + 1)}-${pad(from.getDate())}`,
    toDate: `${to.getFullYear()}-${pad(to.getMonth() + 1)}-${pad(to.getDate())}`,
    label: monthValue,
  };
}

export function currentMonthPickerValue() {
  const d = new Date();
  const pad = (n) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
}

export function staffReportToCsv(analytics, rangeLabel = '') {
  const summary = analytics?.summary || {};
  const staff = Array.isArray(analytics?.staff) ? analytics.staff : [];
  const filters = analytics?.filters || {};
  const period = rangeLabel || `${filters.from || ''} to ${filters.to || ''}`.trim();

  const lines = [
    `Staff performance report,${esc(period)}`,
    '',
    'Summary metric,Value',
    `Active staff,${summary.staffActive ?? 0}`,
    `Total on roster,${summary.staffTotal ?? 0}`,
    `Staff with activity,${summary.staffWithActivity ?? 0}`,
    `Check-ins completed,${summary.checkinsCompleted ?? 0}`,
    `Service lines taken,${summary.serviceLinesTaken ?? 0}`,
    `Flow events,${summary.flowEvents ?? 0}`,
    `Unique guests,${summary.uniqueGuests ?? 0}`,
    `Sales (INR),${summary.sales ?? 0}`,
    '',
    [
      'Staff name',
      'Role',
      'Mobile',
      'Roster status',
      'Check-ins queued',
      'Check-ins done',
      'Services taken',
      'Services completed',
      'Sales (INR)',
      'Flow events',
      'Unique guests',
      'Skin flows',
      'Hair flows',
      'Top services',
    ].join(','),
  ];

  staff.forEach((row) => {
    const top = (row.topServices || []).map((s) => `${s.name} (${s.count})`).join('; ');
    lines.push(
      [
        esc(row.stylistName),
        esc(row.role),
        esc(row.mobile),
        row.isActive === false ? 'Inactive' : row.isActive === true ? 'Active' : '',
        row.checkinsQueued ?? 0,
        row.checkinsCompleted ?? 0,
        row.serviceLinesTaken ?? 0,
        row.serviceLinesCompleted ?? 0,
        row.serviceSales ?? 0,
        row.flowTotal ?? 0,
        row.uniqueGuests ?? 0,
        row.byFlow?.skin_analysis ?? 0,
        row.byFlow?.hair_analysis ?? 0,
        esc(top || '—'),
      ].join(','),
    );
  });

  return lines.join('\n');
}

export function downloadStaffReportCsv(analytics, rangeLabel) {
  const csv = staffReportToCsv(analytics, rangeLabel);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const safe = (rangeLabel || 'report').replace(/[^\w-]+/g, '-');
  link.download = `staff-report-${safe}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
